import React from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Header as UIHeader, HeaderLogo, HeaderNav } from '@voilajsx/uikit/header';
import { useAuth } from '../../features/auth';
import { hasRole, route } from '../utils';
import type { NavigationItem } from '@voilajsx/uikit';
import {
  LayoutDashboard,
  User,
  LogOut,
  Shield,
  LogIn,
  UserPlus,
  Coins,
  History,
} from 'lucide-react';

const APP_NAME = import.meta.env.VITE_APP_NAME === 'plotmagic' ? 'PlotMagic' : 'RRD Planners';

const Logo: React.FC = () => (
  <div className="flex items-center gap-3">
    <div className="w-8 h-8 rounded flex items-center justify-center" style={{ background: 'rgba(255,217,61,0.15)' }}>
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#FFD93D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 21V9" />
      </svg>
    </div>
    <div>
      <h3 style={{ fontSize: '1.25rem', fontWeight: 800, fontStyle: 'italic', color: '#FFD93D' }}>{APP_NAME}</h3>
    </div>
  </div>
);

export const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  const navigationItems: NavigationItem[] = [];

  if (isAuthenticated) {
    navigationItems.push(
      { key: 'dashboard', label: 'Dashboard', href: route('/dashboard'), icon: LayoutDashboard },
      { key: 'credits', label: 'Wallet', href: route('/credits'), icon: Coins },
      { key: 'activity', label: 'Activity', href: route('/activity'), icon: History },
      { key: 'profile', label: 'Profile', href: route('/profile'), icon: User }
    );

    if (user && hasRole(user, ['moderator.manage', 'admin.system'])) {
      navigationItems.push({ key: 'admin', label: 'Admin', href: route('/admin'), icon: Shield });
    }

    navigationItems.push({ key: 'logout', label: 'Sign Out', href: route('/logout'), icon: LogOut });
  } else {
    navigationItems.push(
      { key: 'login', label: 'Sign In', href: route('/auth/login'), icon: LogIn },
      { key: 'register', label: 'Sign Up', href: route('/auth/register'), icon: UserPlus }
    );
  }

  return (
    <UIHeader tone="contrast" size="full" position="sticky">
      <HeaderLogo>
        <Link to={route('/')} style={{ textDecoration: 'none' }}>
          <Logo />
        </Link>
      </HeaderLogo>
      <HeaderNav
        navigation={navigationItems}
        currentPath={location.pathname}
        onNavigate={(href) => navigate(href)}
      />
    </UIHeader>
  );
};

export const PublicHeader = Header;
